// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-path-select {
  display: flex;
}
.dl-path-select__button-content {
  display: flex;
  align-items: center;
}
.dl-path-select__path-text {
  flex: 1 1 auto;
  margin: 0 8px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dl-path-select__button-place {
  max-width: 50%;
}
.dl-path-select__button-place_withInput {
  margin-right: 8px;
}
.dl-path-select__icon-folder, .dl-path-select__icon-chevron {
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/PathSelect/PathSelect.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;AACI;EACI,aAAA;EACA,mBAAA;AACR;AAEI;EACI,cAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;AAAR;AAGI;EACI,cAAA;AADR;AAGQ;EACI,iBAAA;AADZ;AAKI;EAEI,cAAA;AAJR","sourcesContent":[".dl-path-select {\n  display: flex;\n}\n.dl-path-select__button-content {\n  display: flex;\n  align-items: center;\n}\n.dl-path-select__path-text {\n  flex: 1 1 auto;\n  margin: 0 8px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dl-path-select__button-place {\n  max-width: 50%;\n}\n.dl-path-select__button-place_withInput {\n  margin-right: 8px;\n}\n.dl-path-select__icon-folder, .dl-path-select__icon-chevron {\n  flex-shrink: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
